export default {
    // --------Title--------
    walletInfo: "Wallet Info",
    walletKey: "Wallet Key",
    detailsOfWallet: "Details of wallet",
    walletName: "Wallet Name",
    walletCurrency: "Wallet Currency",
    primaryWallet: "Primary Wallet",
    conversionRate: "Conversion Rate",
    description: "Description",
    walletStatus: "Status",
    currencySymbol: "Currency Symbol",
    newWallet: "New Wallet",
    updateWallet: "Update Wallet",
    manageWalletUsers: "Manage Wallet Users",
    wallets: "Wallets",
    isPrimaryWallet: "Is Primary Wallet",
    notPrimaryWallet: "Standard Wallet",

    // ---------- Wallet User---------
    username: "Username",
    firstName: "First Name",
    lastName: "Last Name",
    userType: "User Type"
};